import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";
import { del } from "../../helpers/api_helper";
//redux
import { useNavigate, useParams } from "react-router-dom";
import { CANCEL_ORDER, UNDO_CANCEL_ORDER } from "helpers/api_endpoints";

const RemoveOrder = () => {
    const history = useNavigate();
    const params = useParams();
    const id = params.id;
    const type = params.type;
    const navigate = useNavigate();

    useEffect(() => {
        if(type != 7)
            del(CANCEL_ORDER, { id })
                .then(response => {
                    navigate('/orders', { state: { successMsg: 'Cancelled SuccessFully' } });
                })
                .catch(error => {
                    console.log(error);
                })
        else
            del(UNDO_CANCEL_ORDER, { id })
                .then(response => {
                    navigate('/orders', { state: { successMsg: 'Restored SuccessFully' } });
                })
                .catch(error => {
                    console.log(error);
                })
    });

    return <React.Fragment>Removed</React.Fragment>;
};

export default withRouter(RemoveOrder);